import React from 'react'
import {BsLinkedin} from "react-icons/bs";
import {FaFacebookSquare} from "react-icons/fa";
import {FaTwitterSquare} from "react-icons/fa";
import {FaGithub} from "react-icons/fa";
import {RiPinterestFill} from "react-icons/ri";

const HeaderSocials = () => {
  return (
    <div className='header__socials'>
        <a href="https://www.linkedin.com/feed/" target="_blank"><BsLinkedin/></a>
        <a href="https://web.facebook.com/" target="_blank"><FaFacebookSquare/></a>
        <a href="https://twitter.com/home" target="_blank"><FaTwitterSquare/></a>
        <a href="https://github.com/" target="_blank"><FaGithub/></a>
        <a href="#" target="_blank"><RiPinterestFill/></a>
    </div>
  )
}

export default HeaderSocials